import update from '../utilities/update';
import {loading} from './shared/loading';
import {error} from './shared/error';
import {
    CREATE_TRANSACTION_START,
    CREATE_TRANSACTION_SUCCESS,
    CREATE_TRANSACTION_FAIL,
    TOGGLE_TRANSACTION_ADD_MODAL,
    GET_SMASTER_TRANSACTION_START,
    GET_SMASTER_TRANSACTION_SUCCESS,
    GET_SMASTER_TRANSACTION_FAIL,
    GET_SM_TRANSACTION_DETAIL_START,
    GET_SM_TRANSACTION_DETAIL_SUCCESS,
    GET_SM_TRANSACTION_DETAIL_FAIL,
    GET_MASTER_TRANSACTION_START,
    GET_MASTER_TRANSACTION_SUCCESS,
    GET_MASTER_TRANSACTION_FAIL,
    GET_MASTER_TRANSACTION_DETAIL_START,
    GET_MASTER_TRANSACTION_DETAIL_SUCCESS,
    GET_MASTER_TRANSACTION_DETAIL_FAIL
} from '../actions/transaction/actionTypes';

const initialState={
    loading:false,
    error:null,
    message:null,
    all:[],
    smasterTransaction:[],
    addVisible:false,
    smDetailTransaction:[],
    masterTransaction:[],
    masterDetailTransaction:[],
}

const createTransaction=(state,action)=>{
    return update(state,{
        loading:false,
        message:'create transaction success',
        all:[...state.all,action.payload]
    })
}

const toggleAddModal=(state,action)=>{
    return update(state,{
        addVisible:!state.addVisible
    })
}

const getSmasterTransaction=(state,action)=>{
    return update(state,{
        loading:false,
        smasterTransaction:action.payload
    });
}

const getSmTransactionDetail=(state,action)=>{
    return update(state,{
        loading:false,
        smDetailTransaction:action.payload
    })
}

const getMasterTransaction=(state,action)=>{
    console.log('payload',action.payload)
    return update(state,{
        loading:false,
        masterTransaction:action.payload
    })
}

const getMasterTransactionDetail=(state,action)=>{
    return update(state,{
        loading:false,
        masterDetailTransaction:action.payload
    })
}

const transactionReducer=(state=initialState,action)=>{
    switch(action.type)
    {
        case CREATE_TRANSACTION_START:
            return loading(state,action);
        case CREATE_TRANSACTION_SUCCESS:
            return createTransaction(state,action);
        case CREATE_TRANSACTION_FAIL:
            return error(state,action);
        case TOGGLE_TRANSACTION_ADD_MODAL:
            return toggleAddModal(state,action);
        case GET_SMASTER_TRANSACTION_START:
            return loading(state,action);
        case GET_SMASTER_TRANSACTION_SUCCESS:
            return getSmasterTransaction(state,action);
        case GET_SMASTER_TRANSACTION_FAIL:
            return error(state,action);
        case GET_SM_TRANSACTION_DETAIL_START:
            return loading(state,action);
        case GET_SM_TRANSACTION_DETAIL_SUCCESS:
            return getSmTransactionDetail(state,action);
        case GET_SM_TRANSACTION_DETAIL_FAIL:
            return error(state,action);
        case GET_MASTER_TRANSACTION_START:
            return loading(state,action);
        case GET_MASTER_TRANSACTION_SUCCESS:
            return getMasterTransaction(state,action);
        case GET_MASTER_TRANSACTION_FAIL:
            return error(state,action);
        case GET_MASTER_TRANSACTION_DETAIL_START:
            return loading(state,action);
        case GET_MASTER_TRANSACTION_DETAIL_SUCCESS:
            return getMasterTransactionDetail(state,action);
        case GET_MASTER_TRANSACTION_DETAIL_FAIL:
            return error(state,action);
        default:
            return state;
    }
}

export default transactionReducer;